<template>
  <div class="order_wrap" >
    <div class="order_headers" >
<!--      <img src="https://img2.baidu.com/it/u=4240071095,794567802&fm=26&fmt=auto" />-->
      <van-image :src="storeOrderVo.headImgUrl" class="head_img" round />
      <div class="headers_right" >
        <div>{{ storeOrderVo.nikeName }}</div>
        <div v-if="storeOrderVo.uid && storeOrderVo.userLevelStr" >会员编号：{{ storeOrderVo.uid }}（{{ storeOrderVo.userLevelStr }}）</div>
      </div>
    </div>

    <div class="opt_wrap" >
<!--      <div class="opt_item" @click="logistics" >
        <div>
          <div class="logistics" ></div>
          <div class="logistics_name" >查看物流</div>
        </div>
        <div class="right" ></div>
      </div>-->

      <div class="opt_item" >
        <div>
          <div class="location" ></div>
          <div class="location_name" >收货人：{{ storeOrderVo.realName }}</div>
        </div>
        <div class="right" ></div>
      </div>
    </div>
    <div class="line" ></div>
    <div class="goods_list" >
      <div class="goods_item">
<!--        <img :src="item.image" />-->
        <van-image :src="storeOrderVo.skuImg" radius="5px" class="goods_img" />
        <div class="goods_right" >
          <div>{{ storeOrderVo.productName }}</div>
          <div>
            <div>￥{{ storeOrderVo.productOnePrice }}</div>
            <div>x{{storeOrderVo.payNum}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="order_card" >
      <div class="order_info" >
        <div>订单编号</div>
        <div>{{ storeOrderVo.orderId }}</div>
      </div>
<!--      <div class="order_info" >
        <div>店铺名称</div>
        <div>这里是店铺名字</div>
      </div>
      <div class="order_info" >
        <div>负责人</div>
        <div>张先生</div>
      </div>-->
    </div>

    <div class="order_card" >
      <div class="order_info" >
        <div>订单总额</div>
        <div class="money" >{{ storeOrderVo.payPrice }}元</div>
      </div>
    </div>

    <div class="order_card" >
      <div class="order_info" >
        <div>支付方式</div>
        <div>{{ storeOrderVo.payTypeStr }}</div>
      </div>
    </div>

    <div class="order_card" >
      <div class="order_info" >
        <div>下单时间</div>
        <div>{{ storeOrderVo.createTime }}</div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  getStoreOrderInfo
} from '@/api/order'
export default {
  name: 'orderDetail',
  data() {
    return {
      storeOrderVo: {
        orderProductDetailVoList: []
      },
      orderId: ''
    }
  },
  methods: {
    logistics() {
      this.$router.push({ name: 'logistics', params: { orderId: this.orderId, type: '1' } })
    },
    getStoreOrderInfo() {
      const { orderId } = this.$route.params
      this.orderId = orderId
      getStoreOrderInfo({ orderInfoId: orderId, isShield: '0' }).then(res => {
        console.log(res)
        if(res.success) {
          this.storeOrderVo = res.data
        }
      })
    }
  },
  mounted() {
    this.getStoreOrderInfo()
  }
}
</script>
